import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangePurchaseNetPriceExchangeRateCommand extends BaseCommand {
  CommandName = "ChangePurchaseNetPriceExchangeRate";
  Command: {
    ExchangeRate: number;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, exchangeRate: number) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, ExchangeRate: exchangeRate };
  }
}
